import PerforamanceReportTypes from "./performanceReport.types";

export const performanceReportFetchStart = (performanceReportList: any) => ({
  type: PerforamanceReportTypes.PERFORMANCE_REPORT_FETCH_START,
  payload: performanceReportList,
});

export const performanceReportFetchSuccess = (success: any) => ({
  type: PerforamanceReportTypes.PERFORMANCE_REPORT_FETCH_SUCCESS,
  payload: success,
});

export const performanceReportFetchFailure = (failure: any) => ({
  type: PerforamanceReportTypes.PERFORMANCE_REPORT_FETCH_FAILURE,
  payload: failure,
});

export const performanceReportFetchResetStart = () => ({
  type: PerforamanceReportTypes.PERFORMANCE_REPORT_FETCH_RESET_START,
});

export const performanceReportFetchResponseChanged = () => ({
  type: PerforamanceReportTypes.PERFORMANCE_REPORT_FETCH_RESPONSE_CHANGED,
});
//*****************PERFORMANCE REPORT DATE WISE START******************/

//*******EXPORT PERFORMANCE REPORT********* */
export const performanceReportExportAllStart = (
  performanceReportList: any,
) => ({
  type: PerforamanceReportTypes.PERFORMANCE_REPORT_EXPORT_START,
  payload: performanceReportList,
});
export const performanceReportExportAllSuccess = (success: any) => ({
  type: PerforamanceReportTypes.PERFORMANCE_REPORT_EXPORT_SUCCESS,
  payload: success,
});
export const performanceReportExportAllFailure = (failure: any) => ({
  type: PerforamanceReportTypes.PERFORMANCE_REPORT_EXPORT_FAILURE,
  payload: failure,
});
export const performanceReportExportAllReset = () => ({
  type: PerforamanceReportTypes.PERFORMANCE_REPORT_EXPORT_CHANGED,
});
export const performanceReportExportAllChanged = () => ({
  type: PerforamanceReportTypes.PERFORMANCE_REPORT_EXPORT_RESET_START,
});
